export function SectionHeading({ eyebrow, title, lead, center = true }) {
  return (
    <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <span className="inline-block rounded-full border border-teal-200/60 bg-teal-50 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-teal-700">
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {lead && (
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">{lead}</p>
      )}
    </div>
  );
}
